<template>
	<div class="p-3 remaining-container">
		<b-row class="mb-4">
			<b-col md="6" cols="12">
				<label class="font-weight-bold">{{ $t('promo-to-product.department') }} <span
						class="text-danger">*</span></label>
				<multiselect label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true"
					:show-labels="false" :options="departmentList" v-model="departmentId" @select="disableOption"
					class="multiselect-pricing" :placeholder="$t('promo-to-product.department')" />
				<small v-if="!departmentId" class="text-danger mt-1 d-block">
					Вам необходимо выбрать магазин.
				</small>
			</b-col>
			<b-col md="6" cols="12">
				<label class="font-weight-bold">Поиск <span class="text-danger">*</span></label>
				<div class="d-flex">
					<b-form-input :placeholder="$t('incomes.create.product')" v-model="searchValue" type="text"
						@keyup.enter="getItems" />
					<b-button @click="getItems" variant="dark" class="ml-2">
						<i class="fa fa-search"></i>
					</b-button>
				</div>
			</b-col>
		</b-row>

		<transition name="fade">
			<b-card v-if="itemsList.length > 0" class="product-card shadow-sm border-0 overflow-hidden">
				<b-table :items="itemsList" id="gridContainer" :fields="computedFields" :busy="loading"
					:responsive="true" small bordered show-empty striped hover label-sort-asc="" label-sort-desc=""
					label-sort-clear="">
					<template #table-busy>
						<div class="text-center my-2">
							<b-spinner small class="mr-2" /><strong>Loading...</strong>
						</div>
					</template>

					<template #cell(index)="data">
						{{ data.index + 1 }}
					</template>

					<template #cell(name)="data">
						<span class="font-weight-bold text-dark">{{ data.item.name }}</span>
					</template>

					<template #cell(qty)="data">
						<span class="text-primary font-weight-bold h5 mb-0">{{ data.item.qty }}</span>
					</template>

					<template #cell(priceUzs)="data">
						<span class="text-success font-weight-bold">{{ data.item.priceUzs | currency }}</span>
					</template>

					<template #cell(barcode)="data">
						<code class="text-secondary">{{ data.item.barcode }}</code>
					</template>

					<!-- <template #cell(artikul)="data">
						<span class="text-muted">{{ data.item.artikul ? data.item.artikul.trim() : '' }}</span>
					</template> -->

					<template #empty>
						<div class="text-center p-4">
							<h5 class="text-muted">Ничего не найдено</h5>
						</div>
					</template>
				</b-table>
			</b-card>
		</transition>

		<div v-if="itemsList.length === 0 && !loading && departmentId" class="text-center my-5 empty-state">
			<i class="fa fa-barcode fa-4x mb-3 text-muted"></i>
			<h4>Сканируйте товар или введите SKU</h4>
			<p class="text-muted">Используйте сканер штрих-кода или ручной ввод</p>
		</div>

		<div v-if="loading" class="text-center my-5">
			<b-spinner variant="primary"></b-spinner>
			<p class="mt-2 text-muted">Загрузка данных...</p>
		</div>
	</div>
</template>

<script>
import { BFormSpinbutton, BTableSimple, BTbody, BTd, BTh, BThead, BTr, BFormGroup } from 'bootstrap-vue';
import UsersService from "@/services/users.sevice";
import PosService from "@/services/pos.service";
import { convertRuToEn } from '@/utils/helper';
import Multiselect from 'vue-multiselect'
import { BOverlay } from 'bootstrapVue2';

export default {
	name: "remaining",
	components: {
		Multiselect,
		BFormSpinbutton,
		BTableSimple,
		BThead,
		BTr,
		BTh,
		BTbody,
		BTd,
		BOverlay,
		BFormGroup
	},
	data() {
		return {
			itemsList: [],
			loading: false,
			searchValue: null,
			departmentId: null,
			departmentList: [],
		}
	},
	computed: {
		computedFields() {
			return [
				{ key: 'index', label: '№', thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'name', label: this.$t('goods.name') },
				{ key: 'qty', label: 'Остаток', thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'unitName', label: 'Ед. Изм.', thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'priceUzs', label: 'Цена', thClass: 'text-right', tdClass: 'text-right' },
				// { key: 'artikul', label: this.$t('goods.artikul') },
				{ key: 'barcode', label: this.$t('goods.barcode') },
			]
		}
	},
	watch: {
		// 'departmentId': {
		// 	handler(g) {
		// 		if (g) {
		// 			this.posBarcodeScanned('6905290203459')
		// 		}
		// 	}
		// },
	},
	methods: {
		getDepartments() {
			UsersService.getPermittedDepartments().then(res => {
				this.departmentList = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		disableOption(dep) {
			this.departmentList.forEach(d => {
				d.disabled = d.id === dep.id;
			})
			this.$forceUpdate()
		},
		barcodeDestroy() {
			this.$barcodeScanner.destroy();
		},
		barcodeInit() {
			this.$barcodeScanner.init(this.posBarcodeScanned);
		},

		getItems() {
			if (this.searchValue) {
				this.posBarcodeScanned(this.searchValue);
			}
		},

		posBarcodeScanned(barcodeNumberProps) {
			if (!this.departmentId) {
				this.$vs.notify({
					title: 'Вам необходимо выбрать магазин.',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				return
			}

			let barcodeNumber = convertRuToEn(barcodeNumberProps)

			if (this.loading === false) {
				this.itemsList = []
				this.loading = true
				PosService.searchItemsForRemaining(this.departmentId.id, barcodeNumber).then(res => {
					if (res.data.length > 0) {
						this.itemsList = res.data
					} else {
						this.itemsList = []
						// this.barcodeDestroy();
						this.$bvModal.msgBoxOk(`Товар не найден`, {
							size: 'sm',
							centered: true,
							hideHeader: true,
							noCloseOnEsc: true,
							okVariant: 'success',
							noCloseOnBackdrop: true,
							footerClass: 'bg-danger',
							bodyClass: 'bg-danger h3 bold'
						}).then(value => {
							this.barcodeInit()
						})
					}
					this.loading = false
				}).catch(er => {
					this.loading = false
					this.$vs.notify({
						title: er.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		},
	},
	async created() {
		this.$barcodeScanner.init(this.posBarcodeScanned);
		this.getDepartments();
	}
}
</script>

<style scoped>
.remaining-container {
	background-color: #f4f7fa;
	min-height: 100vh;
}

.product-card {
	border-radius: 8px;
}

.empty-state {
	padding: 3rem;
	background: #fff;
	border-radius: 8px;
	border: 2px dashed #dee2e6;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
